import React from "react";
import {observer} from "mobx-react";
import { SideMenuItemsListBox } from "../side-menu-items/boxes/side-menu-items-list.box";
import {CyClass} from '../../../../common/cy-classes';
import {MenuItemKey} from "../../../services/configurations/config-data-sections/generated-config-const";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {withServices} from "../../../react-hooks/with-services";

export interface SideMenuLinksProps extends ComponentServicesPick<'sideMenu'>{
  menuItemKeys: MenuItemKey[];
  className?: string;
}


const ComponentBody: React.FC<SideMenuLinksProps> = observer((props) => {
    const menuItems = props.menuItemKeys.map(key => props.sideMenu.getMenuItem(key))
        .filter(menuItem => menuItem.display);
    if (menuItems.length === 0) {
        return null;
    }

    return (
        <SideMenuItemsListBox className={props.className}>
            <ul className={CyClass('cy-menu-links-group')} style={{margin: "0", listStyleType: "none"}}>
                {
                    menuItems.map(menuItem => (
                        <React.Fragment key={menuItem.key}>
                            {menuItem.renderMenuItem()}
                        </React.Fragment>)
                    )
                }
            </ul>
        </SideMenuItemsListBox>
    )
})

export const SideMenuLinksGroup = withServices(ComponentBody, ['sideMenu']);